import React from 'react'

const OfferComparision = () => {
    return (
        <div>OfferComparision</div>
    )
}

export default OfferComparision